import React from 'react'
import { ListItemSecondaryAction, List, ListItem, ListItemText, ListItemIcon, IconButton, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import Image from './Image'
import AddIcon from '@material-ui/icons/Add';
import FileReader from 'react-file-reader'
import { useStore } from '../Store'
import { useConfirm } from './ConfirmDialog';
import PhotoDetails from './PhotoDetails';

const Photos = ({ formik, uploads, setUploads, readonly, marginBottom='57px' }) => {
    const { createUpload } = useStore()
    const { confirm } = useConfirm()
    const [upload, setUpload] = React.useState()

    const onAdd = (files) => {
        const item = createUpload()
        item.base64 = files.base64
        item.origname = files.fileList[0].name
        uploads.push(item)
        setUploads(uploads)
    }

    const onDelete = async (item) => {
        const canDelete = await confirm(`Wilt u deze foto verwijderen?`)
        if (canDelete) {
            item.delstaId = 1
            item.dirty = 1
            uploads = uploads.filter(upl => upl.id > 0 || upl.delstaId === 0)
            setUploads(uploads)
        }
    }

    const onSelect = (item) => {
        setUpload({ ...item })
        formik.setFieldValue('upload', { ...item })
    }

    const onSubmit = () => {
        uploads = uploads.map(upl => upl.id === formik.values.upload.id ? formik.values.upload : upl)
        setUploads(uploads)
        setUpload(null)
    }

    const onClose = () => {
        setUpload(null)
        formik.setFieldValue('upload', null)
    }

    return (
        <>
            <List component="nav" aria-label="foto's" style={{ marginBottom: marginBottom }}>
                {uploads.filter(item => !item.delstaId).map((item, i) => (
                    <ListItem button key={item.id} onClick={(e) => onSelect(item)} divider>
                        <ListItemIcon style={{ marginLeft: -15, marginRight: 10, width: 100, height: 75 }}>
                            <Image upload={item} />
                        </ListItemIcon>
                        <ListItemText primary={<Typography noWrap={true}>{(item.author ? `${item.origname} (${item.author})` : item.origname)}</Typography>} secondary={item.remarks} />
                        <ListItemSecondaryAction>
                            {!readonly && <IconButton aria-label="delete" onClick={(e) => onDelete(item)} ><DeleteIcon /></IconButton>}
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
                {!readonly &&
                    <FileReader handleFiles={onAdd} base64={true}>
                        <ListItem button>
                            <ListItemIcon>
                                <AddIcon fontSize='large' color='primary' />
                            </ListItemIcon>
                            <ListItemText primary="Voeg een foto toe" />
                        </ListItem>
                    </FileReader>}
            </List>
            <PhotoDetails
                formik={formik}
                readonly={readonly}
                upload={upload}
                onClose={onClose}
                onSubmit={onSubmit}
            />
        </>
    )
}

export default Photos
